import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from "react-router-dom";
import { GoogleOAuthProvider } from '@react-oauth/google';
import { ThemeProvider as ThemeProviderV5 } from '@mui/material/styles';
import { ThemeProvider as ThemeProviderV4 } from '@material-ui/core/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { themeV5, themeV4 } from './theme';
import App from './App';
import './index.css'
import * as serviceWorker from './serviceWorker';
import {store} from './store/store'
import {Provider} from "react-redux";
import { setupAxiosInterceptors } from './services/googleLoginService';

setupAxiosInterceptors();

const GOOGLE_CLIENT_ID = "407957355038-ubeci87dp59ah74lcloq6qf2eba6a2o8.apps.googleusercontent.com";

ReactDOM.render(
    <React.StrictMode>
        <ThemeProviderV5 theme={themeV5}>
            <ThemeProviderV4 theme={themeV4}>
                <CssBaseline />
                <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
                    <Router>
                        <Provider store={store}>
                            <App/>
                        </Provider>
                    </Router>
                </GoogleOAuthProvider>
            </ThemeProviderV4>
        </ThemeProviderV5>
    </React.StrictMode>,
    document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.register();